import { render, staticRenderFns } from "./NavigationItemFormScreen.vue?vue&type=template&id=1f4e70a6&"
import script from "./NavigationItemFormScreen.vue?vue&type=script&lang=ts&"
export * from "./NavigationItemFormScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports